import styled from 'styled-components';

const StyledInput = styled.input.attrs({ type: 'text' })`
	position: relative;
	max-width: 100%;
	padding: 10px;
	padding-left: 24px;
	border-width: 0;
	border-radius: 4px;
	background-color: #202020;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	font-weight: 500;
	color: #e6e6e6;
	/* text-align: center; */

	&:focus {
		outline: none;
	}
`;

const StyledInputContainer = styled.div`
	position: relative;

	&::after {
		content: '#';
		position: absolute;
		left: 10px;
		top: 0;
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		align-content: center;
		font-family: 'GT Walsheim Pro';
		font-size: 14px;
		font-weight: 500;
		color: #e6e6e6;
		opacity: 0.35;
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledInput, StyledInputContainer };
